import { render, staticRenderFns } from "./Gerenciamento.vue?vue&type=template&id=a86dc384"
import script from "./Gerenciamento.vue?vue&type=script&lang=js"
export * from "./Gerenciamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports